import send from './send';
export default {
  send,
};
